<template>
  <div class="gradient-bg full-screen d-flex position-relative">
    <!-- Floating Background Shapes -->
    <div class="floating-shapes">
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
      <div class="shape shape-4"></div>
      <div class="shape shape-5"></div>
      <div class="shape shape-6"></div>
    </div>

    <!-- Left Section - Branding -->
    <div class="left-section d-none d-lg-flex flex-column justify-content-center align-items-center position-relative">
      <div class="brand-container text-center">
        <div class="brand-logo mb-4">
          <svg class="brand-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5" />
          </svg>
        </div>
        <h1 class="brand-title mb-3">{{ appName || 'HRM Pro' }}</h1>
        <p class="brand-subtitle mb-4">Secure Password Update</p>
      </div>
    </div>

    <!-- Right Section - Reset Password Form -->
    <div class="right-section d-flex align-items-center justify-content-center position-relative">
      <!-- Notification -->
      <div v-show="notification.show" :class="['notification', notification.type, { 'show': notification.show }]">
        {{ notification.message }}
      </div>

      <!-- Card -->
      <div class="login-container">
        <div class="glass-effect login-card position-relative overflow-hidden">

          <!-- Mobile Header -->
          <div class="mobile-header text-center mb-4 d-lg-none">
            <div class="logo-container d-flex align-items-center justify-content-center mx-auto mb-3">
              <img v-if="logoUrl" :src="logoUrl" alt="Logo" class="img-fluid logo">
              <svg v-else class="logo-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16" />
              </svg>
            </div>
            <h2 class="login-title-mobile fw-bold text-white mb-2">{{ appName || 'HRM Pro' }}</h2>
            <p class="login-subtitle-mobile">Reset Password</p>
          </div>

          <!-- Welcome Header -->
          <div class="welcome-header text-center mb-4">
            <h3 class="welcome-title text-white mb-2">{{ $t('reset_password') }}</h3>
            <p class="welcome-subtitle">Enter your new password below</p>
          </div>

          <!-- Reset Password Form -->
          <form class="sign-in-sign-up-form" ref="form" data-url="users/reset-password" @submit.prevent="submitData">

            <!-- Password -->
            <div class="form-group mb-4">
              <label class="form-label text-white fw-medium mb-2">{{ $t('password') }}</label>
              <app-input
                  type="password"
                  :placeholder="$placeholder('your', 'password')"
                  v-model="formData.password"
                  :error-message="$errorMessage(errors, 'password')"
                  :show-password="true"
              />
              <div class="note note-warning p-4 mt-2">
                <p class="m-1" v-html="$t('password_requirements_message')"></p>
              </div>
            </div>

            <!-- Confirm Password -->
            <div class="form-group mb-4">
              <label class="form-label text-white fw-medium mb-2">{{ $fieldTitle('confirm', 'password') }}</label>
              <app-input
                  type="password"
                  :placeholder="$placeholder('confirm', 'password')"
                  v-model="formData.password_confirmation"
                  :error-message="$errorMessage(errors, 'password_confirmation')"
                  :show-password="true"
              />
            </div>

            <!-- Submit Button -->
            <div class="form-group mb-4">
              <button type="submit" :disabled="loading"
                      class="btn login-btn btn-hover w-100 d-flex align-items-center justify-content-center">
                <span>{{ loading ? $t('processing') : $t('change') }}</span>
                <div v-if="loading" class="loading-spinner ms-2"></div>
              </button>
            </div>

            <!-- Footer -->
            <div class="text-center">
              <p class="footer-text mt-3 mb-0">
                {{ $t('copyright') }} © {{ new Date().getFullYear() }} {{ $t('by') }} {{ appName }}
              </p>
            </div>
          </form>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ThemeMixin from "../../../../core/mixins/global/ThemeMixin";
import FormHelperMixins from "../../../Mixin/Global/FormHelperMixins";

export default {
  name: "ResetPassword",
  props: {
    logoUrl: { required: false },
    appName: { required: false },
    user: { required: true, type: String },
    token: { required: true, type: String }
  },
  mixins: [ThemeMixin, FormHelperMixins],
  data() {
    return {
      notification: { show: false, message: '', type: 'success' }
    };
  },
  methods: {
    submitData() {
      this.loading = true;
      this.save(this.formData);
    },
    afterSuccess(response) {
      this.message = response.data.message;
      this.showNotification(this.message, 'success');
      setTimeout(() => {
        window.location = response.data.redirect;
      }, 1500);
    },
    showNotification(message, type = 'success') {
      this.notification.message = message;
      this.notification.type = type;
      this.notification.show = true;
      setTimeout(() => { this.notification.show = false; }, 4000);
    }
  },
  watch: {
    user: {
      handler(user) {
        user = JSON.parse(user);
        this.formData.email = user.email;
        this.formData.token = this.token;
      },
      immediate: true
    }
  },
  mounted() {
    const card = this.$el.querySelector('.login-card');
    card.style.opacity = '0';
    card.style.transform = 'translateY(30px) scale(0.98)';
    setTimeout(() => {
      card.style.transition = 'all 0.8s cubic-bezier(0.4, 0, 0.2, 1)';
      card.style.opacity = '1';
      card.style.transform = 'translateY(0) scale(1)';
    }, 200);
  }
};
</script>

<style scoped>
@import '../../../../../sass/LoginPageStyles.css'; /* reuse login styles */
</style>
